import { GetterTree } from 'vuex'
import { FinalReviewSheet, FinalReviewSheetsState } from '@/store/lessons/finalReviewSheet/types'
import { RootState } from '@/store/types'

const getters : GetterTree<FinalReviewSheetsState, RootState> = {
  /**
   * レッスンIDをもとにFRS情報を取得
   * @param {string} lessonId レッスンのスケジュールID
   */
  findFinalReviewSheetByLessonId: (state) => (lessonId: string): FinalReviewSheet|null => {
    return state.finalReviewSheets.find((frs) => frs.lessonId === lessonId) || null
  },
};

export default getters
